export default "__VITE_PUBLIC_ASSET__d7978d33__"